import {
  API_CALL,
  SAVE_USER,
  SIGNOUT,
  REQUEST_USER_PROFILE
} from "./types";

export const getMe = () => ({
  type: API_CALL,
  onRequest: REQUEST_USER_PROFILE,
  onResponse: SAVE_USER,
  onError: SIGNOUT,
  payload: {
    method: 'GET',
    url: '/users/me'
  }
});
